import './index.scss'
$("header .nav a").eq(2).addClass("active")
$(".play").click(function () {
    var video = document.getElementById('myVideo');
    if (video.paused) { //如果已暂停则播放
        $('.play').hide();
        video.play(); //播放控制
    } else { // 已播放点击则暂停
        $('.play').show();
        video.pause(); //暂停控制
    }
})